<template>
  <v-data-table
    :headers="monthBomDataTableHeaders"
    :items="monthBomList"
    :search="searchMonthBom"
    class="elevation-1"
    show-expand
    single-expand
    item-key="Id"
    :no-data-text="$t('common_no_data')"
    :no-results-text="$t('common_no_results')"
    :loading="isLoadingMonthBom"
    :loading-text="$t('common_get_data')"
    :footer-props="{
      'items-per-page-options': [30, 50, 100],
      'items-per-page-text': $t('item_rows_per_page'),
    }"
    :header-props="headerProps"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>{{ $t('bom_tool_bar_title') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="searchMonthBom"
          append-icon="mdi-magnify"
          :label="$t('bom_search_label')"
          single-line
          hide-details
          clearable
        ></v-text-field>
        <v-dialog v-model="isShowEditMonthBomDialog" fullscreen persistent>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark class="mb-2 ml-8" v-bind="attrs" v-on="on">
              {{ $t('common_new') }}
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ monthBomDialogTitle }}</span>
              <v-spacer></v-spacer>
              <v-btn v-if="editedMonthBomIndex !== -1" icon fab @click="copyMonthBom">
                <v-icon>mdi-content-copy</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-container>
                <ValidationObserver ref="dialogNameAndPrice">
                  <v-row>
                    <v-col cols="12" sm="6" md="4" xl="3" lg="3">
                      <ValidationProvider
                        :name="$t('month_bom_name')"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="editedMonthBom.Name"
                          :error-messages="errors[0]"
                          required
                          clearable
                          :disabled="isAllTextFieldDisable || editedMonthBomIndex !== -1"
                          @keyup.enter="focusNextInput"
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('month_bom_name') }}
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" xl="3" lg="3">
                      <ValidationProvider
                        :name="$t('month_quantity')"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="editedMonthBom.Quantity"
                          :error-messages="errors[0]"
                          required
                          clearable
                          :disabled="isAllTextFieldDisable"
                          @keyup.enter="focusNextInput"
                          @change="setMonthItemQuantity"
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('month_quantity') }}
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" xl="3" lg="3">
                      <ValidationProvider
                        :name="$t('bom_price')"
                        :rules="{ required: true, regex: /^[0-9]+$/ }"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="editedMonthBom.Price"
                          :error-messages="errors[0]"
                          required
                          clearable
                          disabled
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('bom_price') }}
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" xl="3" lg="3">
                      <ValidationProvider
                        :name="$t('bom_unit')"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="editedMonthBom.Unit"
                          :error-messages="errors[0]"
                          required
                          clearable
                          :disabled="isAllTextFieldDisable"
                          @keyup.enter="focusNextInput"
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('bom_unit') }}
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-textarea
                        outlined
                        v-model="editedMonthBom.Describe"
                        :label="$t('bom_describe')"
                        :disabled="isAllTextFieldDisable"
                        @keyup.enter="focusNextInput"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </ValidationObserver>
              </v-container>
            </v-card-text>

            <v-data-table
              :headers="monthBomItemDataTableHeaders"
              :items="editedMonthBom.MonthBomItems"
              :search="searchMonthBomItem"
              class="elevation-1  mt-5 mx-10"
              hide-default-footer
              disable-pagination
              :no-data-text="$t('common_no_data')"
              :no-results-text="$t('common_no_results')"
              :header-props="headerProps"
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title></v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchMonthBomItem"
                    append-icon="mdi-magnify"
                    :label="$t('common_search')"
                    single-line
                    hide-details
                    clearable
                  ></v-text-field>
                  <v-dialog v-model="isShowEditMonthBomItemDialog" persistent>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        dark
                        class="mb-2 ml-8"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="isAllTextFieldDisable"
                      >
                        {{ $t('common_new') }}
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">{{ monthBomItemDialogTitle }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <ValidationObserver ref="dialogBomItem">
                            <v-row>
                              <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                <month-item-autocomplete
                                  :fatherEditedItem="editedMonthBomItem"
                                  :itemName="'month_number'"
                                  @setEditedMonthItem="setEditedItem"
                                  v-if="
                                    editedMonthBomItemIndex === -1 && isShowEditMonthBomItemDialog
                                  "
                                  @keyupEnter="focusNextInput"
                                  refName="itemAutocomplete"
                                />
                                <ValidationProvider
                                  :name="$t('month_number')"
                                  rules="required"
                                  v-slot="{ errors }"
                                  v-else
                                >
                                  <v-text-field
                                    v-model="editedMonthBomItem.Number"
                                    disabled
                                    required
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('month_number') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                <ValidationProvider
                                  :name="$t('month_name')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedMonthBomItem.Name"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('month_name') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                <ValidationProvider
                                  :name="$t('month_quantity')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedMonthBomItem.Quantity"
                                    required
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('month_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                <ValidationProvider
                                  :name="$t('bom_item_price')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedMonthBomItem.Price"
                                    required
                                    :error-messages="errors[0]"
                                    clearable
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('bom_item_price') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-textarea
                                  outlined
                                  disabled
                                  v-model="editedMonthBomItem.Remark"
                                  :label="$t('quotation_item_remark')"
                                ></v-textarea>
                              </v-col>
                            </v-row>
                          </ValidationObserver>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="closeEditMonthBomItem">
                          {{ $t('common_cancel') }}
                        </v-btn>
                        <v-btn color="green darken-1" text @click="addMonthBomItem">
                          {{ $t('common_confirm') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <delete-dialog
                    :isAllTextFieldDisable="isAllTextFieldDisable"
                    :isLoadingSaveBtn="isLoadingSaveBtn"
                    :isShowDeleteDialog="isShowDeleteMonthBomItemDialog"
                    :deleteMessage="'month_bom_item_delete_dialog_message'"
                    @closeDelete="closeDeleteMonthBomItem"
                    @confirmDelete="confirmDeleteMonthBomItem"
                  />
                </v-toolbar>
              </template>
              <template v-slot:[`item.Edit`]="{ item }">
                <v-btn icon @click="isShowEditMonthBomItemDialogBtn(item)">
                  <v-icon small>
                    mdi-pencil
                  </v-icon>
                </v-btn>
                <v-btn icon @click="isShowDeleteMonthBomItemDialogBtn(item)">
                  <v-icon small>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="red darken-1"
                text
                @click="closeEditMonthBomDialog"
                :disabled="isAllTextFieldDisable"
              >
                {{ $t('common_cancel') }}
              </v-btn>
              <v-btn color="green darken-1" text @click="saveMonthBom" :loading="isLoadingSaveBtn">
                {{ $t('common_save') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="isMonthBomItemNullDialog" max-width="500" persistent>
          <v-card color="error">
            <v-card-title class="text-h1"></v-card-title>
            <v-card-text class="white--text text-h5">
              <v-icon class="white--text text--lighten-1">mdi-alert-octagon</v-icon>
              {{ $t('bom_save_alert') }}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="white" text @click="isMonthBomItemNullDialog = false">
                {{ $t('common_close') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <delete-dialog
          :isAllTextFieldDisable="isDeleteBtnDisable"
          :isLoadingSaveBtn="isLoadingDeleteBtn"
          :isShowDeleteDialog="isShowDeleteMonthBomDialog"
          :deleteMessage="'month_bom_delete_dialog_message'"
          @closeDelete="closeDeleteMonthBom"
          @confirmDelete="confirmDeleteMonthBom"
        />
      </v-toolbar>
    </template>
    <template v-slot:[`item.CreateTime`]="{ item }">
      {{ convertToDateTimeFormat(item.CreateTime) }}
    </template>
    <template v-slot:[`item.Edit`]="{ item }">
      <v-btn icon @click="isShowEditMonthBomDialogBtn(item)">
        <v-icon small>
          mdi-pencil
        </v-icon>
      </v-btn>
      <v-btn icon @click="isShowDeleteMonthBomDialogBtn(item)">
        <v-icon small>
          mdi-delete
        </v-icon>
      </v-btn>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" style="background-color: rgb(223, 219, 219);">
        <v-simple-table style="background-color: rgb(223, 219, 219);">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  {{ $t('month_number') }}
                </th>
                <th class="text-left">
                  {{ $t('month_name') }}
                </th>
                <th class="text-right">
                  {{ $t('month_quantity') }}
                </th>
                <th class="text-right">
                  {{ $t('bom_item_price') }}
                </th>
                <th class="text-left">
                  {{ $t('quotation_item_remark') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="simpleItem in item.MonthBomItems" :key="simpleItem.Number">
                <td class="text-left">{{ simpleItem.Number }}</td>
                <td class="text-left">{{ simpleItem.Name }}</td>
                <td class="text-right">{{ simpleItem.Quantity }}</td>
                <td class="text-right">{{ simpleItem.Price }}</td>
                <td class="text-left">{{ simpleItem.Remark }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import { extend } from 'vee-validate'
import { regex } from 'vee-validate/dist/rules'
import { HttpMonthBom } from '@/js/http-Manager'
import MonthItemAutocomplete from '@/components/MonthItemAutocomplete.vue'
import DeleteDialog from '@/components/DeleteDialog.vue'
import axios from 'axios'

extend('regex', regex)

export default {
  components: { MonthItemAutocomplete, DeleteDialog },
  name: 'MonthBom',
  data () {
    return {
      getIntersectingObj: null,
      isShowEditMonthBomDialog: false,
      isShowDeleteMonthBomDialog: false,

      searchMonthBom: '',
      monthBomList: [],
      editedMonthBomIndex: -1,
      editedMonthBom: {
        Number: '',
        Name: '',
        Price: 0,
        Unit: '組',
        Quantity: 0,
        Describe: '',
        MonthBomItems: [],
        CreateTime: 0,
        CreateBy: '',
        UpdateTime: 0,
        UpdateBy: ''
      },
      defaultMonthBom: {
        Number: '',
        Name: '',
        Price: 0,
        Unit: '組',
        Describe: '',
        Quantity: 0,
        MonthBomItems: [],
        CreateTime: 0,
        CreateBy: '',
        UpdateTime: 0,
        UpdateBy: ''
      },

      isShowEditMonthBomItemDialog: false,
      isShowDeleteMonthBomItemDialog: false,

      searchMonthBomItem: '',
      editedMonthBomItemIndex: -1,
      editedMonthBomItem: {
        Number: '',
        Name: '',
        Quantity: 0,
        Price: 0,
        Remark: ''
      },
      defaultMonthBomItem: {
        Number: '',
        Name: '',
        Quantity: 0,
        Price: 0,
        Remark: ''
      },
      isLoadingMonthBom: true,
      isLoadingSaveBtn: false,
      isAllTextFieldDisable: false,
      isLoadingDeleteBtn: false,
      isDeleteBtnDisable: false,
      isMonthBomItemNullDialog: false,
      bomSource: null,
      updateBomSource: null,
      addBomSource: null,
      deleteBomSource: null
    }
  },

  computed: {
    monthBomDialogTitle () {
      return this.editedMonthBomIndex === -1 ? this.$t('bom_new_btn') : this.$t('bom_edit_btn')
    },
    monthBomItemDialogTitle () {
      return this.editedMonthBomItemIndex === -1 ? this.$t('common_new') : this.$t('common_edit')
    },
    monthBomDataTableHeaders () {
      return [
        { text: this.$t('month_bom_name'), value: 'Name' },
        { text: this.$t('bom_describe'), value: 'Describe' },
        { text: this.$t('month_quantity'), value: 'Quantity' },
        { text: this.$t('bom_price'), value: 'Price' },
        { text: this.$t('bom_create_time'), value: 'CreateTime' },
        { text: this.$t('bom_create_by'), value: 'CreateBy' },
        { text: this.$t('common_edit'), value: 'Edit', sortable: false },
        { text: '', value: 'data-table-expand', sortable: false }
      ]
    },
    monthBomItemDataTableHeaders () {
      return [
        { text: this.$t('month_number'), value: 'Number' },
        { text: this.$t('month_name'), value: 'Name' },
        { text: this.$t('month_quantity'), value: 'Quantity' },
        { text: this.$t('bom_item_price'), value: 'Price' },
        { text: this.$t('quotation_item_remark'), value: 'Remark' },
        { text: this.$t('common_edit'), value: 'Edit', sortable: false }
      ]
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    }
  },
  async mounted () {
    this.getAllMonthBoms()
  },
  methods: {
    setMonthItemQuantity () {
      if (this.editedMonthBom.Quantity > 0) {
        this.editedMonthBom.MonthBomItems.forEach((element) => {
          element.Quantity = this.editedMonthBom.Quantity
        })
        this.editedMonthBom = JSON.parse(JSON.stringify(this.editedMonthBom))
        this.computedTotalPrice()
      }
    },
    computedTotalPrice () {
      let totalPrice = 0
      this.editedMonthBom.MonthBomItems.forEach((element) => {
        totalPrice += element.Quantity * element.Price * 1
      })
      this.editedMonthBom.Price = totalPrice
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (
          form[i].type !== 'hidden' &&
          !form[i].disabled &&
          !form[i].readOnly &&
          form[i].type !== 'checkbox'
        ) {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    setEditedItem (val) {
      this.editedMonthBomItem = JSON.parse(JSON.stringify(val))
      this.editedMonthBomItem.Quantity = this.editedMonthBom.Quantity
    },
    convertToDateTimeFormat (timestamp) {
      return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
    },
    isShowEditMonthBomDialogBtn (item) {
      this.editedMonthBomIndex = this.monthBomList.indexOf(item)
      let str = JSON.stringify(item)
      this.editedMonthBom = JSON.parse(str)
      this.isShowEditMonthBomDialog = true
    },

    isShowDeleteMonthBomDialogBtn (item) {
      this.editedMonthBomIndex = this.monthBomList.indexOf(item)
      let str = JSON.stringify(item)
      this.editedMonthBom = JSON.parse(str)
      this.isShowDeleteMonthBomDialog = true
    },

    async confirmDeleteMonthBom () {
      this.isLoadingDeleteBtn = true
      this.isDeleteBtnDisable = true
      this.isLoadingMonthBom = true
      if (this.deleteBomSource) {
        this.deleteBomSource.cancel('cancel')
      }
      let cancelToken = axios.CancelToken
      this.deleteBomSource = cancelToken.source()
      await HttpMonthBom.DeleteMonthBom(
        this.monthBomList[this.editedMonthBomIndex].Id,
        this.deleteBomSource.token
      )
      this.deleteBomSource = null
      this.isLoadingDeleteBtn = false
      this.isDeleteBtnDisable = false
      this.isLoadingMonthBom = false
      await this.getAllMonthBoms()
      this.closeDeleteMonthBom()
    },

    async closeEditMonthBomDialog () {
      this.isShowEditMonthBomDialog = false
      this.isLoadingSaveBtn = false
      this.isAllTextFieldDisable = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultMonthBom)
        this.editedMonthBom = JSON.parse(str)
        this.editedMonthBomIndex = -1
      })
      await this.getAllMonthBoms()
    },

    closeDeleteMonthBom () {
      this.isShowDeleteMonthBomDialog = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultMonthBom)
        this.editedMonthBom = JSON.parse(str)
        this.editedMonthBomIndex = -1
      })
    },
    async getAllMonthBoms () {
      if (this.bomSource) {
        this.bomSource.cancel('cancel')
      }
      let cancelToken = axios.CancelToken
      this.bomSource = cancelToken.source()
      let response = await HttpMonthBom.GetAllMonthBoms(this.bomSource.token)
      this.isLoading = false
      if (response) {
        this.monthBomList = response.status === 200 ? response.data.Data : []
        this.bomSource = null
      }
      this.isLoadingMonthBom = false
    },

    async saveMonthBom () {
      let isExist =
        this.editedMonthBom.Id !== ''
          ? this.monthBomList.findIndex(
            (x) =>
              x.Id !== this.editedMonthBom.Id &&
                x.Name === this.editedMonthBom.Name &&
                x.Describe === this.editedMonthBom.Describe
          ) !== -1
          : this.monthBomList.findIndex(
            (x) =>
              x.Name === this.editedMonthBom.Name && x.Describe === this.editedMonthBom.Describe
          ) !== -1
      if (!isExist) {
        const isValid = await this.$refs.dialogNameAndPrice.validate()
        if (isValid) {
          if (this.editedMonthBom.MonthBomItems.length === 0) {
            this.isMonthBomItemNullDialog = true
          } else {
            this.isLoadingSaveBtn = true
            this.isLoadingMonthBom = true
            this.setAllTextFieldDisable()
            if (this.editedMonthBomIndex > -1) {
              if (this.updateBomSource) {
                this.updateBomSource.cancel('cancel')
              }
              let cancelToken = axios.CancelToken
              this.updateBomSource = cancelToken.source()
              await HttpMonthBom.UpdateMonthBom(this.editedMonthBom, this.updateBomSource.token)
              this.updateBomSource = null
            } else {
              if (this.addBomSource) {
                this.addBomSource.cancel('cancel')
              }
              let cancelToken = axios.CancelToken
              this.addBomSource = cancelToken.source()
              await HttpMonthBom.AddMonthBom(this.editedMonthBom, this.addBomSource.token)
              this.addBomSource = null
            }
            await this.getAllMonthBoms()
            this.closeEditMonthBomDialog()
          }
        }
      } else {
        alert('此月租BOM已存在')
      }
    },
    setAllTextFieldDisable () {
      this.isAllTextFieldDisable = true
    },

    isShowEditMonthBomItemDialogBtn (item) {
      this.editedMonthBomItemIndex = this.editedMonthBom.MonthBomItems.indexOf(item)
      let str = JSON.stringify(item)
      this.editedMonthBomItem = JSON.parse(str)
      this.isShowEditMonthBomItemDialog = true
    },

    isShowDeleteMonthBomItemDialogBtn (item) {
      this.editedMonthBomItemIndex = this.editedMonthBom.MonthBomItems.indexOf(item)
      let str = JSON.stringify(item)
      this.editedMonthBomItem = JSON.parse(str)
      this.isShowDeleteMonthBomItemDialog = true
    },

    confirmDeleteMonthBomItem () {
      this.editedMonthBom.MonthBomItems.splice(this.editedMonthBomItemIndex, 1)
      this.computedTotalPrice()
      this.closeDeleteMonthBomItem()
    },

    closeEditMonthBomItem () {
      this.isShowEditMonthBomItemDialog = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultMonthBomItem)
        this.editedMonthBomItem = JSON.parse(str)
        this.editedMonthBomItemIndex = -1
      })
    },

    closeDeleteMonthBomItem () {
      this.isShowDeleteMonthBomItemDialog = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultMonthBomItem)
        this.editedMonthBomItem = JSON.parse(str)
        this.editedMonthBomItemIndex = -1
      })
    },
    async addMonthBomItem () {
      const isValid = await this.$refs.dialogBomItem.validate()
      if (isValid) {
        if (this.editedMonthBomItemIndex > -1) {
          this.editedMonthBom.MonthBomItems.splice(
            this.editedMonthBomItemIndex,
            1,
            this.editedMonthBomItem
          )
        } else {
          this.editedMonthBom.MonthBomItems.push(this.editedMonthBomItem)
        }
        this.computedTotalPrice()
        this.closeEditMonthBomItem()
      }
    },
    copyMonthBom () {
      this.editedMonthBom.Id = ''
      this.editedMonthBomIndex = -1
    }
  }
}
</script>
